import { render, staticRenderFns } from "./FileHistory.vue?vue&type=template&id=2a6aaf5c&scoped=true&"
import script from "./FileHistory.vue?vue&type=script&lang=js&"
export * from "./FileHistory.vue?vue&type=script&lang=js&"
import style0 from "./FileHistory.vue?vue&type=style&index=0&id=2a6aaf5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6aaf5c",
  null
  
)

export default component.exports